import { memo } from "react";

//scss
import "./style.scss";

//helpers
import AmenityIcon from "components/ListingNew/ListingNormal/AmenityIcon";
import { ReactComponent as MarriottbonvoyIcon } from "assets/marriottbonvoy.svg";

import { SvgMariottListing } from "assets/icons/js/SvgMariottListing";

import { ReactComponent as SafeIcon } from "assets/100%Safe.svg";
import { useTheme } from "components/ListingNew/ListingTheme";

const IconText = memo((props) => {
	const theme = useTheme();
	if (props?.title === "Marriott Bonvoy Home") {
		if (theme?.name === "xseries") {
			return <SvgMariottListing />;
		}
		return <MarriottbonvoyIcon id="marriot-icon" />;
	}
	if (props?.title === "100% Safe To Travel") {
		return (
			<SafeIcon
				style={{
					maxWidth: 150,
				}}
			/>
		);
	}
	return (
		<>
			{props.type !== "amen" ? (
				<div className={"icon-text__wrapper " + props.className}>
					{!Object.keys(props) ? (
						Object.keys(props)
					) : (
						<AmenityIcon id={Object.keys(props)} />
					)}
					<div className="text-sm-light" style={{ color: theme.baseTextColor }}>
						{Object.values(props)}
					</div>
				</div>
			) : (
				<div className={"icon-text__wrapper " + props.className}>
					{props.icon ? props.icon : <AmenityIcon id={props.id} />}
					<div className="text-sm-light" style={{ color: theme.baseTextColor }}>
						{props.title}
					</div>
				</div>
			)}
		</>
	);
});

export default IconText;
